<div class="container-fluid">
	<dropdown-area class="noprint"></dropdown-area>
	<dropdown-school class="noprint"></dropdown-school>
	<!-- <app-phase-select class="noprint" style="margin-top: 10px"></app-phase-select> -->
	<div class="tab" role="tabpanel">
		<div class="card h-100">
			<my-tabs>
				<my-tab tabTitle="Growth Chart">
					<div class="tw-flex tw-flex-row tw-gap-2 md:tw-gap-4 tw-relative">
						<div class="tw-min-w-[200px] print:tw-hidden tw-relative tw-z-10">

						</div>
						<div class="tw-flex-1 tw-h-full tw-relative tw-z-10">
							<app-reading-achievement-phases [node]="selectedSchool" class="reading-achievement"></app-reading-achievement-phases>
						</div>
					</div>
				</my-tab>
				<my-tab [tabTitle]="'School'">
					<h3 class="print">
						Phonics Advantage Reading Assessment<br />
						{{ selectedSchool?.name }}
					</h3>
					<div class="row">
						<div class="col">
							<div class="h-100">
								<app-assessments-bar></app-assessments-bar>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<div class="h-100">
								<app-number-of-students-per-challenge [node]="selectedSchool" [classrooms]='classrooms'></app-number-of-students-per-challenge>
							</div>
						</div>
					</div>
				</my-tab>
				<my-tab tabTitle="Classroom">
					<h3 class="print">
						Phonics Advantage Reading Assessment<br />
						{{ selectedSchool?.name }} -
						{{ phaseService.phase.title }}
					</h3>
					<div class="row">
						<div class="col">
							<dropdown-classroom class="noprint"></dropdown-classroom>
							 <app-progress-table-accordion></app-progress-table-accordion>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<div class="h-100">
								<app-number-of-students-per-challenge [node]="selectedClassroom" ></app-number-of-students-per-challenge>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col" style="padding-bottom: 30px">
							<div class="h-100 noprint">
								<export-data-card [node]="this?.selectedSchool"></export-data-card>
							</div>
						</div>
					</div>
				</my-tab>
			</my-tabs>
		</div>
	</div>
</div>
